import { useEffect, initTooltips } from "@";
import { memo } from "react";

const Tooltip = ({ id, title, className, hint }) => {
  useEffect(() => {
    initTooltips();
  }, []);

  return (
    <span
      id={id}
      role="tooltip"
      className={`tooltip invisible absolute z-[50] inline-flex min-w-min items-center whitespace-nowrap rounded-2xl border border-gray-200 bg-white px-3 py-2 text-sm font-semibold capitalize text-gray-700 opacity-0 shadow-lg shadow-gray-900/5 backdrop-blur-md transition-opacity duration-300 dark:border-gray-700/60 dark:text-gray-200 dark:shadow-black/30 ${className ? className : "dark:bg-gray-800/95"}`}
    >
      {title}

      {/* {hint && (
        <span className="ms-3 inline-flex items-center rounded-md bg-gradient-to-br from-gray-100 to-gray-50 px-2 py-0.5 font-mono text-[11px] font-medium text-gray-500 ring-1 ring-gray-200 dark:from-purple-900 dark:to-purple-800 dark:text-purple-100 dark:ring-purple-700">
          {hint}
        </span>
      )} */}
    </span>
  );
};

export default memo(Tooltip);
